import { useState, type MouseEvent } from "react";
import clsx from "clsx";
import { Tooltip } from "@mui/material";

import kutil, { type PageInfo } from "@modules/kutil";
import commonCode, { type Code } from "@modules/common_code";
import valueFormatter from "@modules/value_formatter";

import router from "@user/router";
import { useTabsStore } from "@user/store/tabs_store";
import { useAuthStore } from "@user/store/auth_store";

import arrowIcon from "@user/assets/images/common/chevron-down.svg";
import homeIcon from "@user/assets/images/common/home.svg";
import dashboardIcon from "@user/assets/images/common/grid.svg";
import closeIcon from "@user/assets/images/common/close.svg";
import deleteIcon from "@user/assets/images/common/cancel.svg";

export default function Left({ onClose }: { onClose: () => void }) {
  const MAIN_TAB_ID = "/";
  const tabs = useTabsStore((state) => state.tabs);
  const currTabId = useTabsStore((state) => state.currTabId);
  const menuInfos = useAuthStore((state) => state.menuInfos);
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const [openFavorite, setOpenFavorite] = useState<string | null>(null);

  const toggleMenuOpen = (menu: string) => {
    setOpenMenu((prev) => (prev === menu ? null : menu));
  };

  const toggleFavoriteOpen = (menu: string) => {
    setOpenFavorite((prev) => (prev === menu ? null : menu));
  };

  function changeTab(id: string) {
    useTabsStore.getState().changeTab(id);
  }

  function removeFavorite(e: MouseEvent, id: string) {
    e.stopPropagation();
    useTabsStore.getState().unsetFavorite(id);
  }

  return (
    <>
      <div className="left-area">
        {/* 상단 버튼 */}
        <div className="left-top">
          <div>
            <Tooltip title="홈">
              <button className={clsx("icon-button", currTabId === MAIN_TAB_ID && "on")} onClick={() => router.navigateByPath("/")}><img src={homeIcon} alt="홈" /></button>
            </Tooltip>
            <Tooltip title="대시보드">
              <button className="icon-button" onClick={() => router.navigateByPath("/common/dashboard")}><img src={dashboardIcon} alt="Dashboard" /></button>
            </Tooltip>
          </div>
          <Tooltip title="메뉴 닫기">
            <button className="icon-button" onClick={onClose}><img src={closeIcon} alt="닫기" /></button>
          </Tooltip>
        </div>
        {/*// 상단 버튼 */}
        {/* 메뉴 영역 */}
        <div className="left-menu">
          {/* 즐겨찾기 */}
          <div className="favorite-menu">
            <button onClick={() => toggleFavoriteOpen("fav1")} className="btn-base">
              <img src={arrowIcon}
                style={{
                  transform:
                    openFavorite === "fav1" ? "rotate(180deg)" : "rotate(0deg)",
                }}
              />
              즐겨찾기
            </button>
            <div className="sub-menu"
              style={{
                maxHeight: openFavorite === "fav1" ? 600 : 0,
              }}
            >
              {tabs.map((tab: any) => (
                tab.isFavorite &&
                <button key={tab.id} className="btn-sub" onClick={() => changeTab(tab.id)}>
                  {tab.label}
                  <Tooltip title="삭제">
                    <a onClick={(e) => removeFavorite(e, tab.id)}><img src={deleteIcon} alt="삭제" /></a>
                  </Tooltip>
                </button>
              ))}
            </div>
          </div>
          <div className="divider hor"></div>
          {/* 메뉴 */}
          <div className="menu">
            {menuInfos.map((menu) => (
              <div key={menu.menuId}>
                <button onClick={() => toggleMenuOpen(menu.menuId)} className="btn-base">
                  <img src={arrowIcon}
                    style={{
                      transform:
                        openMenu === menu.menuId ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                  {menu.menuName}
                </button>
                <div className="sub-menu"
                  style={{
                    maxHeight: openMenu === menu.menuId ? 600 : 0,
                  }}
                >
                  {menu.children.map((subMenu) => (
                    <button 
                      key={subMenu.menuId}
                      className={clsx(
                        "btn-sub",
                        subMenu.menuId == currTabId && "selected"
                      )}
                      onClick={() => router.navigateByPath(subMenu.menuUrl)}
                    >
                      {subMenu.menuName}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        {/*// 메뉴 영역 */}
      </div>
    </>
  );
}
